import React, { Component } from 'react'
import { connect } from 'react-redux'
import VaultResUpdateCC from '../samples/VaultResUpdateCC'
import { makeVaultResUpdateCC } from '../../../actions/vaultAction'
import { updateOrderId } from '../../../actions/commonActions'
import { _VAULT } from '../../../actions/types'

const OBJECT = [  "resUpdateCC", "resUpdateCC", "resUpdateCC"]
const METHODS = { 
    SetEncTrack2:[  ".SetEncTrack2(enc_track2);", ".SetEncTrack2(enc_track2);", "'enc_track2'=>$enc_track2"],
    SetDeviceType:[  ".SetDeviceType;", ".SetDeviceType;", "'device_type'=>$device_type"],
    SetCusId: [  ".SetCustId(cust_id);", ".setCustId(cust_id);", "'cust_id'=>$cust_id"],
    SetAvsCheck: [  ".SetAvsInfo(avsCheck);", ".setAvsInfo(avsCheck);", "$mpgTxn->setAvsInfo($mpgAvsInfo);"],
    SetEmail: [  ".SetEmail(email);", ".setEmail(email);", "'email'=>$email"],
    SetPhone: [  ".SetPhone(phone);", ".setPhone(phone);", "'phone'=>$phone"],
    SetNote: [  ".SetNote(note);", ".setNote(note);", "'note'=>$note"],
    SetDataKeyFormat: [  ".SetDataKeyFormat(data_key_format);", ".SetDataKeyFormat(data_key_format);", "'data_key_format'=>$data_key_format"],
    SetDataKey: [  ".setData(data_key);", ".setData(data_key);", "'data_key'=>$data_key"],
    CreditCardNumber: [  ".SetPan(pan);", ".setPan(pan);", "'pan'=>$pan"],
    ExpiryDay: [  ".setExpdate(expiry_date);", ".setExpdate(expiry_date);", "'expdate'=>$expiry_date"],
    SetDuration: [  ".SetDuration(duration);", ".SetDuration(duration);", "'duration'=>$duration"],
    CreditCardCumber: [  ".SetPan(pan);", ".setPan(pan);", "'pan'=>$pan"],
    SetCryptType: [  ".SetCryptType(crypt);", ".setCryptType(crypt);", "'crypt_type'=>$crypt"],    
    setCotInfo: [  ".SetCofInfo(cof);", ".setCofInfo(cof);", "$mpgTxn->setCofInfo($cof);"],
    SetIssueId: [  `{cof.SetIssuerId("VALUE_FOR_ISSUER_ID");}`, `{cof.SetIssuerId("VALUE_FOR_ISSUER_ID");}`, `{$cof->setIssuerId("VALUE_FOR_ISSUER_ID");}`],
}

export class VaultUpdateCC extends Component {
    state = {
        showError:false,
        showSuccess:false,
        justClicked:false,
      };
    async generateOrderId() {
        const d = new Date();
        var orderId = "Test";
        orderId += d.getFullYear().toString();
        orderId += d.getMonth().toString();
        orderId += d.getDay().toString();
        orderId += d.getHours().toString();
        orderId += d.getMinutes().toString();
        orderId += d.getSeconds().toString();
        return orderId;
    }

    renderMessage() {
        if(this.state.showError) {
            return (
                <div style={{ marginTop:'-2vh', marginRight: '3vw',backgroundColor:'#ffcccc', color:'#cc0000', padding:'1vw', borderRadius:'10px', border:'1px solid #ff8080', lineHeight: '3vh'}}>
                    <strong>Error!</strong><br />
                    Please check your parameters within Vault ResUpdateCC.
                </div>
            );
        }
        // else if(this.state.showSuccess) {
        //     return (
        //         <div style={{ marginTop:'-2vh', marginRight: '3vw',backgroundColor:'#d6f5d6', color:'#196719', padding:'1vw', borderRadius:'10px', border:'1px solid #6fdc6f', lineHeight: '3vh'}}>
        //             <strong>Vault ResUpdateCC Accepted!</strong><br />
        //             The returned receipt has been inserted to the JSON on the right, you can make another Vault Request now.
        //         </div>
        //     );
        // }
    }

    //TODO fix this
    componentDidUpdate() {
        const { resupdateSuccess,ResUpdateResponse,loading } = this.props; 
        if(ResUpdateResponse!=="No request has been made."  && this.state.justClicked){
            if(resupdateSuccess){
                    this.setState({ showError: false,showSuccess: true,justClicked:false });  
                }
            else {
                if(!loading){
                    this.setState({  showError: true, showSuccess: false,justClicked:false });
                }
            }
        }
    }
    //TODO fix this
    async onMakeUpdatePress() {
        const newOrderId = await this.generateOrderId();
        this.props.updateOrderId({ featureId: _VAULT, orderId: newOrderId });
        const { storeId, apiToken, order_id, pan, expdate, amount } = this.props;
        const updateRequest = { storeId, apiToken, order_id, pan, expdate, amount };
        this.props.makeVaultResUpdateCC(updateRequest);
        this.setState({justClicked:true});
    }

    renderIntegrationTool() {
        return (
            <div className="stepMainContainer">
                <h3>Sample ResUpdateCC</h3>
                <VaultResUpdateCC/>
                <div className="requestButton" onClick={() => this.onMakeUpdatePress()}>
                    ResUpdateCC Request
                </div> 
                {this.renderMessage()}
            </div>
        );
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderIntegrationTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }

    renderDocument() { 
        const { progLangId } = this.props;
        return (
            <div className="stepPageContainer">  
            <div>
            <h3 className="stepPageTitle">Vault Update Credit Card – ResUpdateCC</h3>
            <p>Updates an existing Vault profile (referencing the profile's unique <b>data key</b>) with cardholder information.<br/>
                Information contained within a credit card profile is updated as indicated by the submitted fields; if any
                field representing an item of cardholder information is not sent in this request, that item will remain
                unchanged in the profile.<br/>
                If the Vault profile is being updated with a new credit card number, then you first need to send a
                Purchase, Pre-Authorization or Card Verification transaction, with the Credential on File Info object
                included, before performing Vault Update Credit Card. If the credit card number is not one of the profile
                items being updated, this step is not required.
            </p>

            <div className='thingsToConsider'>
                <h3>Things to Consider: </h3> 
                <ul>
                    <li>To update a specific element in the profile, set that element using the corresponding set method
                    </li>
                    <li>When updating a credit card number, first send a Purchase, Pre-Authorization, or Card
                        Verification with the Credential on File Info object before sending this transaction; send
                        the issuer ID received in the response in the subsequent Vault Update Credit Card
                        request
                    </li>
                    <li>If the credit card number is not one of the profile items being updated, the Credential
                        on File info object is not required
                    </li>
                </ul>
            </div> 

            <p><b>Vault Update Credit Card transaction object definition</b></p>
            {(() => {
                    switch(progLangId) {
                        case 0:
                            return <code>ResUpdateCC resUpdateCC = new ResUpdateCC();
                            </code>
                        case 1:
                            return <code>ResUpdateCC resUpdateCC = new ResUpdateCC();

                            </code>
                        case 2:
                            return <code>
                                {`$txnArray = array(‘type’=>’res_update_cc', …);`}<br/>
                                {`$mpgTxn = new mpgTransaction($txnArray);`}
                                </code>
                        default:
                            return null
                        }
                    })()}<br/>
            <p><b>HttpsPostRequest object for Vault Update Credit Card transaction</b></p>   
            {(() => {
                    switch(progLangId) {
                        case 0:
                            return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();
                            </code>
                        case 1:
                            return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();

                            </code>
                        case 2:
                            return <code>
                                {`$mpgRequest = new mpgRequest($mpgTxn);`}
                                </code>
                        default:
                            return null
                        }
                    })()}<br/>
                                {(() => {
                    switch(progLangId) {
                        case 0:
                            return <code>mpgReq.SetTransaction(resUpdateCC);
                            </code>
                        case 1:
                            return <code>mpgReq.setTransaction(resUpdateCC);

                            </code>
                        case 2:
                            return <code>
                                {`$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);`}
                                </code>
                        default:
                            return null
                        }
                    })()}


        <h3 className="stepPageTitle" style={{ fontSize:"1.2vw"}}>Vault Update Credit Card transaction request fields – Required</h3>
        <p>For a full description of mandatory and optional values, see Appendix A Definition of Request Fields.</p>
            <table style={{maxWidth:"100%", width:"100%"}}>
            <tbody>
                <tr>
                    
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>
                </tr>
                <tr>
                    <td>data key</td>
                    <td>String<br/>max 20-character alphanumeric</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetDataKeyFormat[progLangId]}</code></td>
                </tr>
                </tbody>
            </table>
            <p>Optional values that are submitted to the ResUpdateCC object are updated. Unsubmitted optional values
                (with one exception) remain unchanged. This allows you to change only the fields you want.<br/>If a profile contains AVS information, but a Vault Update Credit Card transaction is submitted without an
                AVS Info object, the existing AVS Info details are deactivated and the new credit card information is
                registered without AVS
            .</p>
        <h3 className="stepPageTitle" style={{ fontSize:"1.2vw"}}>Vault Update Credit Card transaction request fields – Optional</h3>
            <table style={{maxWidth:"100%", width:"100%"}}>
            <tbody>
                <tr>
                    
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>
                </tr>

                <tr>
                    <td>credit card number</td>
                    <td>String<br/>20-character alphanumeric</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.CreditCardNumber[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>expiry date<br /></td>
                    <td>String<br/>4-character alphanumeric<br/> YYMM</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.ExpiryDay[progLangId]}</code></td>
                </tr>

                <tr>
                    <td>electronic commerce indicator<br /></td>
                    <td>String<br/>1-character alphanumericc</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetCryptType[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>customer ID</td>
                    <td>String<br/>
                        50-character alphanumeric<br/> 
                            <p className="note">
                                <strong>NOTE: </strong> 
                                Some special characters are not
                                allowed:
                                {`< > $ % = ? ^ { } [ ] \\`}
                            </p>
                        </td>
                        <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetCusId[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>email address<br /></td>
                    <td>String<br/>30-character alphanumeric</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetEmail[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>phone number<br /></td>
                    <td>String<br/>30-character alphanumeric</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetPhone[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>note</td>
                    <td>String<br/>30-character alphanumeric</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetNote[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>AVS Information</td>
                    <td>Object<br/>N/A</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetAvsCheck[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>Credential on File Info<br/>cof<br/>                        
                            <p className="note">
                                <strong>NOTE: </strong> 
                                This is a nested object
                                within the transaction, and
                                required when storing or
                                using the customer's stored
                                credentials. For information
                                about fields in the Credential
                                on FIle Info object, see Credential
                                on File Info Object
                                and Variables.
                            </p>
                        </td>
                    <td>Object<br/>N/A</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.setCotInfo[progLangId]}</code></td>

                </tr>
                <tr>
                    <td>issuer ID<br/>                        
                            <p className="note">
                                <strong>NOTE: </strong> 
                                This variable is
                                required for all merchant-initiated
                                transactions following
                                the first one; upon sending
                                the first transaction, the
                                issuer ID value is received in
                                the transaction response and
                                then used in subsequent
                                transaction requests.
                            </p>
                    </td>
                    <td>String<br/>15-character alphanumeric variable length</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetIssueId[progLangId]}</code><br/>
                            <p className="note">
                                <strong>NOTE: </strong> 
                                For a list and explanation of the
                                possible values to send for this variable,
                                see Definition of Request Fields – Credential
                                on File
                            </p>
                        </td>
                </tr>


                </tbody>
            </table> 
          </div>
        </div>
        )
    }
}




const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { resupdateSuccess,ResUpdateResponse,loading } = state.vault.main;
    const { storeId, apiToken, order_id, pan, expdate, amount} = state.vault.main.config;
    return { mode, storeId, apiToken, order_id, pan, expdate, amount,loading, progLangId: state.common.progLangList.selection,resupdateSuccess,ResUpdateResponse };
  }

export default connect(mapStateToProps,{updateOrderId,makeVaultResUpdateCC})(VaultUpdateCC) 


